module.exports = __webpack_public_path__ + "ddba79ebf0073bf8e64fa6e410b81d28.eot";